import { FC } from 'react';
import styles from './PunchupCheckbox.module.css';

export interface PunchupCheckboxProps {
	checked: boolean;
	onChange: () => void;
	label: string;
	disabled?: boolean;
	title?: string;
}

/**
 * PunchupCheckbox
 *
 * Single checkbox row with a label. Use for multi-select lists where each
 * item is an independent boolean toggle (e.g. ticket-type assignment in pools).
 * Not for boolean form fields — use PunchupFormToggle for those.
 *
 * Custom implementation (hidden native input + styled span) so that border
 * colour, border-radius, and hover states are fully under design-system control.
 * Native <input type="checkbox"> ignores border/border-radius CSS.
 */
export const PunchupCheckbox: FC<PunchupCheckboxProps> = ({ checked, onChange, label, disabled, title }) => (
	<label className={`${styles.container} ${disabled ? styles.containerDisabled : ''}`} title={title}>
		{/* Hidden native input — provides keyboard, screen-reader, and form semantics */}
		<input type="checkbox" className={styles.hiddenInput} checked={checked} onChange={onChange} disabled={disabled} />

		{/* Custom visual box — fully design-system-controlled */}
		<span className={`${styles.box} ${checked ? styles.boxChecked : ''}`} aria-hidden="true">
			{checked && (
				<svg className={styles.checkIcon} viewBox="0 0 10 8" fill="none" aria-hidden="true">
					<path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			)}
		</span>

		<span className={styles.labelText}>{label}</span>
	</label>
);
